/* Fichas de producto (escritorio): una foto cada vez. Rueda o trackpad sobre la foto: abajo = siguiente, arriba = anterior.
   En la primera y la ultima, la inercia del mismo gesto no mueve la pagina; un gesto nuevo si. */
(function () {
  if (!window.matchMedia('(min-width: 981px)').matches) return;
  var pdp = document.querySelector('.pdp2'), gal = pdp && pdp.querySelector('.gal');
  if (!gal) return;
  /* 29-oct-2026 (Edgar): fichas por colores (la gorra): solo cuentan las fotos y miniaturas que se ven (sin [hidden]); al cambiar
     de color, la ficha lanza «mg:gal» (script mg-pdp-color de sections/mg-product.liquid) y aquí se rehace la lista. Sin fotos
     escondidas, todo igual que antes. */
  var allZ = [].slice.call(gal.querySelectorAll(':scope > .z'));
  if (allZ.length < 2) return;
  function vis(a) { return a.filter(function (n) { return !n.hidden; }); }
  var zs = vis(allZ);
  pdp.classList.add('pdps');
  var allT = [].slice.call(pdp.querySelectorAll('.thumbs button'));
  var thumbs = vis(allT);
  var N = zs.length || 1, cur = 0;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  var num = document.createElement('div'); num.className = 'pdps-n'; num.setAttribute('aria-hidden', 'true');
  var bar = document.createElement('div'); bar.className = 'pdps-bar'; bar.innerHTML = '<i></i>';
  gal.appendChild(num); gal.appendChild(bar);
  var fill = bar.firstChild; fill.style.height = (100 / N) + '%';
  function go(j) {
    j = Math.max(0, Math.min(N - 1, j));
    cur = j;
    zs.forEach(function (z, k) {
      z.classList.toggle('is-on', k === j); z.classList.toggle('is-up', k < j);
      z.classList.remove('on');                       // fuera el zoom al cambiar
      var im = z.querySelector('img'); if (im && Math.abs(k - j) <= 1) im.loading = 'eager';
    });
    thumbs.forEach(function (b, k) { b.classList.toggle('on', k === j); });
    num.innerHTML = '<b>' + pad(j + 1) + '</b>/ ' + pad(N);
    fill.style.transform = 'translateY(' + (j * 100) + '%)';
  }
  go(0);
  pdp.addEventListener('mg:gal', function () {
    allZ.forEach(function (z) { z.classList.remove('is-on', 'is-up', 'on'); });
    zs = vis(allZ); thumbs = vis(allT); N = zs.length || 1;
    fill.style.height = (100 / N) + '%';
    go(0);
  });
  // miniaturas: cambian la foto en vez de hacer scroll
  var tb = pdp.querySelector('.thumbs');
  if (tb) tb.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-goto]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    go(thumbs.indexOf(b));
  }, true);
  // rueda / trackpad
  var lock = 0, acc = 0, last = 0, gest = 0, changed = -1;
  gal.addEventListener('wheel', function (e) {
    var now = performance.now();
    if (now - last > 280) gest = now;
    last = now;
    var d = e.deltaY > 0 ? 1 : -1;
    if ((d > 0 && cur >= N - 1) || (d < 0 && cur <= 0)) {
      if (changed >= gest || now < lock) e.preventDefault();
      acc = 0; return;
    }
    e.preventDefault();
    if (now < lock) return;
    acc += e.deltaY;
    if (Math.abs(acc) < 30) return;
    acc = 0; lock = now + 900; changed = now;
    go(cur + d);
  }, { passive: false });
  // teclado: flechas arriba/abajo con el raton sobre la foto
  var over = false;
  gal.addEventListener('mouseenter', function () { over = true; });
  gal.addEventListener('mouseleave', function () { over = false; });
  document.addEventListener('keydown', function (e) {
    if (!over) return;
    if (e.key === 'ArrowDown' && cur < N - 1) { e.preventDefault(); go(cur + 1); }
    if (e.key === 'ArrowUp' && cur > 0) { e.preventDefault(); go(cur - 1); }
  });
})();
